import { useI18n } from 'vue-i18n'

export const useFormatTableDate = () => {
  const { d } = useI18n()

  return function formatDate(date?: string | null) {
    if (!date) {
      return '-'
    }

    return d(date, 'ddmmyy')
  }
}
